const date = new Date();
const requestURL = `/update.json?v=${date.getSeconds()}`;
const request = new XMLHttpRequest();
request.open("GET", requestURL);
request.responseType = "json";
request.send();
request.onload = function() {
  const data = request.response;
  if (localStorage.getItem("quarter-version") != data.version) {
    localStorage.setItem("quarter-version", data.version);
    localStorage.removeItem("manage-api_token");
    localStorage.removeItem("cms-api_token");
    localStorage.removeItem("platform-api_token");
    location.reload();
  }
};
